import { Color } from '@diritto/common/style/color';
import { IconProps } from '@diritto/common/style/icon';

export const ArrowRightSlimIcon = ({ size = 16, color = Color.Gray400 }: IconProps) => (
  <svg width={size} height={(size * 24) / 16} viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.17256 19L12 12.0043L5.17256 5L4 6.20292L9.64657 12.0043L4 17.7971L5.17256 19Z" fill={color} />
  </svg>
);
